import React from 'react';
import { Skeleton } from '@heroui/react';
import { Widget } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * Placeholder that mirrors the Suppliers toolbar + grid layout so the page
 * doesn't shift when the real rows swap in.
 */
export const SuppliersPageSkeleton: React.FC = () => {
    return (
        <section aria-busy {...getNodeTestIdProp('suppliers-page-loading')}>
            <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <Skeleton className="h-10 w-full rounded-xl sm:w-72" />
                <Skeleton className="h-10 w-32 rounded-xl" />
            </div>
            <Widget
                className="flex flex-col gap-0 overflow-hidden p-0"
                {...getNodeTestIdProp('suppliers-page-loading-widget')}
            >
                <div className="flex flex-col gap-3 p-4">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div
                            className="flex items-center gap-4"
                            key={`suppliers-page-loading-row-${index}`}
                        >
                            <Skeleton className="size-10 rounded-[8px]" />
                            <Skeleton className="h-4 flex-1 rounded-md" />
                            <Skeleton className="h-4 w-32 rounded-md" />
                            <Skeleton className="h-4 w-40 rounded-md" />
                            <Skeleton className="h-4 w-24 rounded-md" />
                        </div>
                    ))}
                </div>
            </Widget>
        </section>
    );
};
